import { difference, uniqBy } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import AppStore from 'store/AppStore'
import ProgressCard from '../../../../components/card/ProgressCard'
import Checkbox from '../../../../components/forms/Checkbox'
import Input from '../../../../components/forms/Input'
import NumberField from '../../../../components/forms/NumberField'
import RadioButtons from '../../../../components/forms/RadioButtons'
import ReferenceLevelHelp from '../../../../components/echart/ReferenceLevelHelp'
import Select from '../../../../components/forms/Select'
import DtoHydrometricStation from '../../../../hydrometry/dto/DtoHydrometricStation'
import { INSTALLATION_TYPES } from '../../../../installation/constants/InstallationConstants'
import DtoParametrageDataType from '../../../../piezometry/dto/DtoParametrageDataType'
import DtoPiezometerLight from '../../../../piezometry/dto/DtoPiezometerLight'
import PluviometerDto from '../../../../pluviometry/dto/PluviometerDto'
import DtoSandreCode from '../../../../referencial/dto/DtoSandreCode'
import DtoContributor from '../../../../station/dto/DtoContributor'
import { setModal } from '../../../../utils/FormUtils'
import { getHardHydroDataTypes } from '../../../../utils/HydroUtils'
import { getIntegrationModes, getMeasureCoteList } from '../../../../utils/JobUtils'
import { hasValue } from '../../../../utils/NumberUtil'
import { getHardPiezoDataTypes } from '../../../../utils/PiezometryUtils'
import { execByType, getStations } from '../../../../utils/StationUtils'
import { getQualificationSelectOptions, getStatusSelectOptions } from '../../../../utils/StatusUtil'
import { arrayOf, getSandreList, removeNullKeys } from '../../../../utils/StoreUtils'
import JobAction from '../../../actions/JobAction'
import Job from '../../../dto/DtoJob'
import CSVGenericAdvancedModal from './CSVGenericAdvancedModal'
import ImportFileModal from './ImportFileModal'
import DtoInstallationLight from '../../../../installation/dto/installation/DtoInstallationLight'
import { DefaultDialogTitle } from '../../../../components/styled/Dialog'
import { Button, Dialog, DialogActions, DialogContent, Grid, Typography } from '@mui/material'
import { FieldsetTreatmentMUI, StyledFieldSet, StyledLegend } from '../../../../components/StyledElements'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import { nbPerPageLabelMedium, SANDRE } from '../../../../referencial/constants/ReferencialConstants'
import { CardTable } from '../../../../components/datatable/NewTable'
import IntegrationModeDialog from '../IntegrationModeDialog'
import { STATION_TYPE_NAME } from 'station/constants/StationConstants'
import StationAction from 'station/actions/StationAction'
import { ShapePointPrelLight } from 'station/shapes/StationShapes'
import InputIcon from '@mui/icons-material/Input'


class CSVGenericPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataLoaded: false,
            progress: 0,
            importParamsPopupIsOpen: false,
            fileContent: null,
            tmpDataCategory: undefined,
        }
    }

    componentDidMount() {
        AppStore.dispatch(JobAction.loadCSVImportPanel(p => this.setState({ progress: p }), () => this.setState({ dataLoaded: true })))
        this.loadPointsPrel(this.getFilters().dataCategory)
    }

    // Charge les points de prélèvement du type sélectionné (piézo/hydro/pluvio uniquement — pas d'installation)
    loadPointsPrel = (dataCategory) => {
        if ([STATION_TYPE_NAME.piezometry, STATION_TYPE_NAME.hydrometry, STATION_TYPE_NAME.pluviometry].includes(dataCategory)) {
            AppStore.dispatch(StationAction.fetchStationPointsPrel(dataCategory))
        }
    }

    onChangeJobParameter = (changes) => {
        const jobParameters = {
            ...this.props.job.parameters,
            ...changes,
        }
        this.props.onChangeJob({ parameters: jobParameters })
    }

    onChangeParametersNew = (currentParameter, index, changes) => {
        const jobParameters = {
            ...this.props.job.parameters,
            parameters: Object.assign([], this.props.job.parameters.parameters, {
                [index]: JSON.stringify(removeNullKeys({ ...currentParameter, ...changes })),
            }),
        }
        this.props.onChangeJob({ parameters: jobParameters })
    }

    clearParameters = () => {
        const jobParameters = {
            ...this.props.job.parameters,
            parameters: [],
        }
        this.props.onChangeJob({ parameters: jobParameters })
    }

    onChangeFilters = (changes) => {
        const parametersToUpdate = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters: parametersToUpdate })
    }

    updateDataCategory = (dataCategory) => {
        const parametersToUpdate = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                dataCategory,
            })],
            parameters: [],
        }
        this.setState({ tmpDataCategory: undefined })
        this.props.onChangeJob({ parameters: parametersToUpdate })
        this.loadPointsPrel(dataCategory)
    }

    onChangeColumns = (parameter, index, id, column) => {
        const actualData = parameter.data || []
        const newData = (() => {
            if (!hasValue(column)) {
                return actualData.filter(d => d.id !== id)
            }
            return uniqBy([{ id, column }, ...actualData], 'id')
        })()
        this.onChangeParametersNew(parameter, index, { data: newData })
    }

    findData = (parameter, id) => {
        const found = (parameter.data || []).find(d => d.id === id)
        return found ? found.column : null
    }

    getFilters = () => {
        const newFilters = this.props.job.parameters.filters.length ? JSON.parse(this.props.job.parameters.filters[0]) : {}
        return { measureCote: 2, unwantedColumns: ['conditionColumn', 'requiredValue', 'autoDetectCode', 'pointPrelevement', 'tempRef', 'pointPrelCol', 'status', 'qualification', 'initialPoint', 'cdSandre', 'valueUnit'], ...newFilters }
    }

    getParametersNew = () => this.props.job.parameters.parameters.length ? this.props.job.parameters.parameters.map(p => JSON.parse(p)) : []

    getDataTypes = (filters) => execByType(filters.dataCategory, {
        pluviometry: () => this.props.pluviometryDataTypes,
        piezometry: () => uniqBy([ ...getHardPiezoDataTypes(), ...this.props.piezometryDataTypes ], 'id'),
        hydrometry: () => uniqBy([ ...this.props.hydrometryDataTypes, ...getHardHydroDataTypes() ], 'id'),
        installation: () => this.props.installationDataTypes,
        default: () => [],
    })

    onDeleteParameter = (index) => {
        const jobParameters = {
            ...this.props.job.parameters,
            parameters: this.props.job.parameters.parameters.filter((_, i) => i !== index),
        }
        this.props.onChangeJob({ parameters: jobParameters })
    }

    onDuplicateParameter = (index) => {
        const jobParameters = {
            ...this.props.job.parameters,
            parameters: [ ...this.props.job.parameters.parameters, this.props.job.parameters.parameters[index] ],
        }
        this.props.onChangeJob({ parameters: jobParameters })
    }

    setAdvancedFtpModal =() => {
        setModal({
            title: i18n.importParam,
            content: <ImportFileModal url={this.props.job.parameters.path } />,
        })
    }

    getStationsByDataCategory = (dg) => {
        const filters = this.getFilters()
        const dataCategory = dg || filters.dataCategory
        return getStations(this.props, dataCategory)
            .map(s => ({ ...s, name: s.code ? `[${s.code}] ${s.name}` : s.name }))
            .filter(s => dataCategory !== 'installation' || s.installationType === filters.installationType)
    }

    getParametersData = (filters, parameters) => {
        const disabled = { disabled: !this.props.isEditMode }
        return parameters.map((p, index) => {
            const columnFields = this.getDataTypes(filters).reduce((acc, val) => ({
                ...acc,
                [`data${val.id}`]: <NumberField value={ this.findData(p, val.id) } onChange={ v => this.onChangeColumns(p, index, val.id, v) } {...disabled }/>,
            }), {})
            return {
                INDEX_VALUE_ROW: index,
                directory: { value: <Input value={ p.directory } onChange={ v => this.onChangeParametersNew(p, index, { directory: v }) } {...disabled }/>, sortValue: p.directory },
                filter: { value: <Input value={ p.filter } onChange={ v => this.onChangeParametersNew(p, index, { filter: v }) } {...disabled }/>, sortValue: p.filter },
                coeff: { value: <NumberField value={ p.factor } onChange={ v => this.onChangeParametersNew(p, index, { factor: v }) } floatValue {...disabled }/>, sortValue: p.factor },
                offset: { value: <NumberField value={ p.offset } onChange={ v => this.onChangeParametersNew(p, index, { offset: v }) } floatValue {...disabled }/>, sortValue: p.offset },
                date: { value: <NumberField value={ p.dateColumn } onChange={ v => this.onChangeParametersNew(p, index, { dateColumn: v }) } {...disabled }/>, sortValue: p.dateColumn },
                hour: { value: <NumberField value={ p.hourColumn } onChange={ v => this.onChangeParametersNew(p, index, { hourColumn: v }) } {...disabled }/>, sortValue: p.hourColumn },
                station: { value: (
                    <Select options={ this.getStationsByDataCategory() }
                        onChange={ (_, v) => v && v.id ? this.onChangeParametersNew(p, index, { stationCode: v.code, stationId: v.id }) : null }
                        value={ p.stationId } keyValue='id' disabled={ disabled.disabled || p.autoDetectCode }
                    />
                ), sortValue: p.stationId },
                excelTab: { value: <Input value={ p.sheet } onChange={ v => this.onChangeParametersNew(p, index, { sheet: v }) } {...disabled }/>, sortValue: p.sheet },
                sandreCode: { value: <NumberField value={ p.sandreCode } onChange={ v => this.onChangeParametersNew(p, index, { sandreCode: v }) } {...disabled }/>, sortValue: p.sandreCode },
                value: { value: <NumberField value={ p.value } onChange={ v => this.onChangeParametersNew(p, index, { value: v }) } {...disabled }/>, sortValue: p.value },
                cdSandre: { value: <NumberField value={ p.cdSandre } onChange={ v => this.onChangeParametersNew(p, index, { cdSandre: v }) } {...disabled }/>, sortValue: p.cdSandre },
                unit: { value: <NumberField value={ p.unit } onChange={ v => this.onChangeParametersNew(p, index, { unit: v }) } {...disabled }/>, sortValue: p.unit },
                valueUnit: { value: <Input value={ p.valueUnit } onChange={ v => this.onChangeParametersNew(p, index, { valueUnit: v }) } {...disabled }/>, sortValue: p.valueUnit },
                conditionColumn: { value: <NumberField value={ p.conditionColumn } onChange={ v => this.onChangeParametersNew(p, index, { conditionColumn: v }) } {...disabled }/>, sortValue: p.conditionColumn },
                requiredValue: { value: <Input value={ p.requiredValue } onChange={ v => this.onChangeParametersNew(p, index, { requiredValue: v }) } {...disabled }/>, sortValue: p.requiredValue },
                autoDetectCode: { value: <Checkbox checked={ p.autoDetectCode } label={i18n.autoDetectCode} onChange={ v => this.onChangeParametersNew(p, index, { autoDetectCode: v }) } {...disabled } />, sortValue: p.autoDetectCode },
                predictDate: { value: <NumberField value={ p.simulationDateColumn } onChange={ v => this.onChangeParametersNew(p, index, { simulationDateColumn: v }) } {...disabled }/>, sortValue: p.simulationDateColumn },
                horizon: { value: <NumberField value={ p.predictHorizon } onChange={ v => this.onChangeParametersNew(p, index, { predictHorizon: v }) } {...disabled }/>, sortValue: p.predictHorizon },
                pointPrelevement: { value: (
                    <Select
                        options={ (this.props.pointsPrelByType[filters.dataCategory] || []).filter(pt => pt.idStation === p.stationId) }
                        value={ p.pointPrelevement }
                        keyValue='code'
                        keyLabel='name'
                        onChange={ v => this.onChangeParametersNew(p, index, { pointPrelevement: v }) }
                        {...disabled }
                    />
                ), sortValue: p.pointPrelevement },
                tempRef: { value: <Select options={getSandreList(this.props.sandreCodes, SANDRE.REF_TEMPORELLES)} value={ p.tempRef } onChange={ v => this.onChangeParametersNew(p, index, { tempRef: v }) } {...disabled }/>, sortValue: p.tempRef },
                pointPrelCol: { value: <NumberField value={ p.pointPrelCol } onChange={ v => this.onChangeParametersNew(p, index, { pointPrelCol: v }) } {...disabled }/>, sortValue: p.pointPrelCol },
                status: { value: <NumberField value={ p.status } onChange={ v => this.onChangeParametersNew(p, index, { status: v }) } {...disabled }/>, sortValue: p.status },
                qualification: { value: <NumberField value={ p.qualification } onChange={ v => this.onChangeParametersNew(p, index, { qualification: v }) } {...disabled }/>, sortValue: p.qualification },
                initialPoint: { value: <NumberField value={ p.initialPoint } onChange={ v => this.onChangeParametersNew(p, index, { initialPoint: v }) } {...disabled }/>, sortValue: p.initialPoint },
                ...columnFields,
            }
        })
    }

    setAdvancedModal = (filters) => {
        setModal({
            title: i18n.settingsToDisplay,
            actions: (
                <div>
                    <a className='waves-effect waves-teal btn-flat modal-close'>{ i18n.close }</a>
                </div>
            ),
            content: <CSVGenericAdvancedModal unwantedColumns={ filters.unwantedColumns } onChange={ v => this.onChangeFilters({ unwantedColumns: v }) } dataTypes={ this.getDataTypes(filters) } />,
        })
    }

    onUploadFile = (e) => {
        const reader = new FileReader()
        const file = e.target.files[0]
        if (file) {
            reader.onloadend = (event) => {
                const split = event.target.result.split(',')
                this.setState({ fileContent: split[1] })
            }
            reader.readAsDataURL(file)
        }
    }

    importParams = (headers, dataCategory) => {
        JobAction.jobCsvImport(this.props.job.id, headers, this.state.fileContent, dataCategory).then(() => this.props.fetchFullJob(this.props.job.id, 10).then(job => {
            const parameters = JSON.parse(job.parameters).parameters
            const jobParameters = {
                ...this.props.job.parameters,
                parameters,
            }
            this.props.onChangeJob({ parameters: jobParameters })
            this.setState({ importParamsPopupIsOpen: false })
        }))
    }

    importParamsPopin = (fileHeaders, dataCategory) => {
        return (
            <Dialog maxWidth='lg' open={this.state.importParamsPopupIsOpen}>
                <DefaultDialogTitle
                    title={i18n.importParameters}
                    onClose={() => {
                        this.setState({ importParamsPopupIsOpen: false })
                    }}
                />
                <DialogContent>
                    <Grid size={12} paddingTop={1}>
                        <StyledFieldSet>
                            <StyledLegend>{i18n.fileLabel}</StyledLegend>
                            <Typography>{i18n.pleaseUseSameFileExmport}</Typography>
                            <div className='file-field input-field'>
                                <div className='btn'>
                                    <span>{i18n.select}</span>
                                    <input
                                        type='file'
                                        onChange={this.onUploadFile}
                                    />
                                </div>
                                <div className='file-path-wrapper'>
                                    <input className='file-path validate' type='text' />
                                </div>
                            </div>
                        </StyledFieldSet>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent='flex-end' alignItems='flex-end'>
                        <Grid container justifyContent='flex-end'>
                            <Button variant='contained' onClick={() => this.importParams(fileHeaders, dataCategory) }>
                                {i18n.importLabel}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        )
    }

    onChangeDataCategory = (value) => {
        const { job } = this.props
        if (!job.parameters.parameters.length) {
            return this.updateDataCategory(value)
        }
        return this.setState({ tmpDataCategory: value })
    }

    render() {
        const { tmpDataCategory } = this.state

        const filters = this.getFilters()
        const parameters = this.getParametersData(filters, this.getParametersNew())
        if (this.state.dataLoaded) {
            const disabled = !this.props.isEditMode
            const dataTypes = [
                { value: 'pluviometry', label: i18n.pluviometry },
                { value: 'piezometry', label: i18n.piezometry },
                { value: 'hydrometry', label: i18n.hydrometry },
                { value: 'installation', label: i18n.installation },
            ]
            const baseHeaders = ['nullValue', 'nullValue2', 'directory', 'filter', 'autoDetectCode', 'station', 'pointPrelevement', 'tempRef', 'pointPrelCol', 'excelTab', 'conditionColumn', 'requiredValue', 'coeff', 'offset', 'date', 'sandreCode', 'value', 'cdSandre', 'unit', 'valueUnit', 'status', 'qualification', 'initialPoint']
            const hourColumn = filters.hourWithDate ? [] : ['hour']
            const columnHeaders = this.getDataTypes(filters).map(type => `data${type.id}`)
            const customHeaders = this.getDataTypes(filters).reduce((acc, val) => ({ ...acc, [`data${val.id}`]: val.label }), {
                sandreCode: i18n.colParameter,
                value: i18n.colResult,
                cdSandre: i18n.valueParameter,
                unit: i18n.colUnit,
            })
            const predictColumns = filters.predictMode ? ['predictDate', 'horizon'] : []
            const filtersHeaders = difference([ ...baseHeaders, ...hourColumn, ...predictColumns, ...columnHeaders ], filters.unwantedColumns)
            const fileHeaders = difference([ ...baseHeaders, ...hourColumn, ...predictColumns, ...columnHeaders ], [...filters.unwantedColumns, 'nullValue', 'nullValue2', 'rename', 'realVolume'])


            return (
                <Grid spacing={2}>
                    <FieldsetTreatmentMUI title={i18n.defaultValue}>
                        <Grid container spacing={2}>
                            <Grid size={2}>
                                <Select
                                    label={ i18n.status }
                                    value={ filters.status }
                                    onChange={ v => this.onChangeFilters({ status: v }) }
                                    options={ getStatusSelectOptions() }
                                    nullLabel='&nbsp;'
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={2}>
                                <Select
                                    label={ i18n.qualification }
                                    value={ filters.qualification }
                                    onChange={ v => this.onChangeFilters({ qualification: v }) }
                                    options={ getQualificationSelectOptions() }
                                    nullLabel='&nbsp;'
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={2}>
                                <Select
                                    label={ i18n.tempRef }
                                    value={ filters.tempRef }
                                    onChange={ v => this.onChangeFilters({ tempRef: v }) }
                                    options={ getSandreList(this.props.sandreCodes, SANDRE.REF_TEMPORELLES) }
                                    nullLabel='&nbsp;'
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={6}>
                                <MultiContributorsAutocomplete
                                    label={ i18n.producer }
                                    values={ filters.producer }
                                    onChange={ v => this.onChangeFilters({ producer: v }) }
                                    options={ this.props.contributors }
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={2}>
                                <Select
                                    label={ i18n.measureNature }
                                    value={ filters.nature }
                                    onChange={ v => this.onChangeFilters({ nature: v }) }
                                    options={ getSandreList(this.props.sandreCodes, SANDRE.PIEZOMETER_MEASURE_NATURE, true) }
                                    nullLabel='&nbsp;'
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={2}>
                                <Select
                                    label={ i18n.obtainningMode }
                                    value={ filters.obtainingMode }
                                    onChange={ v => this.onChangeFilters({ obtainingMode: v }) }
                                    options={ getSandreList(this.props.sandreCodes, SANDRE.OBTAINING_MODE) }
                                    nullLabel='&nbsp;'
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={4}>
                                <MultiContributorsAutocomplete
                                    label={ i18n.administrator }
                                    values={ filters.manager }
                                    onChange={ v => this.onChangeFilters({ manager: v }) }
                                    options={ this.props.contributors }
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={4}>
                                <MultiContributorsAutocomplete
                                    label={ i18n.validator }
                                    values={ filters.validator }
                                    onChange={ v => this.onChangeFilters({ validator: v }) }
                                    options={ this.props.contributors }
                                    disabled={ disabled }
                                />
                            </Grid>
                        </Grid>
                    </FieldsetTreatmentMUI>
                    <FieldsetTreatmentMUI title={i18n.separator}>
                        <Grid container spacing={2} alignItems={'center'}>
                            <Grid size={2} marginTop={1}>
                                <Checkbox
                                    label={ i18n.comma }
                                    onChange={ v => this.onChangeFilters({ commaSeparator: v }) }
                                    disabled={ disabled }
                                    checked={ filters.commaSeparator }
                                />
                            </Grid>
                            <Grid size={2} marginTop={1}>
                                <Checkbox
                                    label={i18n.semicolon }
                                    onChange={ v => this.onChangeFilters({ semicolonSeparator: v }) }
                                    disabled={ disabled }
                                    checked={ filters.semicolonSeparator }
                                />
                            </Grid>
                            <Grid size={2} marginTop={1}>
                                <Checkbox
                                    label={ i18n.space }
                                    onChange={ v => this.onChangeFilters({ spaceSeparator: v }) }
                                    disabled={ disabled }
                                    checked={ filters.spaceSeparator }
                                />
                            </Grid>
                            <Grid size={2} marginTop={1}>
                                <Checkbox
                                    label={ i18n.tabulation }
                                    onChange={ v => this.onChangeFilters({ tabulationSeparator: v }) }
                                    disabled={ disabled }
                                    checked={ filters.tabulationSeparator }
                                />
                            </Grid>
                            <Grid size={4}>
                                <Input
                                    title={ i18n.otherSeparator }
                                    onChange={ v => this.onChangeFilters({ customSeparator: v !== '' ? v : null }) }
                                    disabled={ disabled }
                                    value={ filters.customSeparator }
                                />
                            </Grid>
                        </Grid>
                    </FieldsetTreatmentMUI>
                    <Grid container spacing={2} alignItems='center' margin={1}>
                        <Grid size={4} marginTop={1}>
                            <Checkbox
                                label={ i18n.renameDoneErrorFic }
                                onChange={ v => this.onChangeFilters(v ? { renameProcessedFiles: true, dontProcessFilesInLogs: false } : { renameProcessedFiles: false }) }
                                disabled={ disabled }
                                checked={ filters.renameProcessedFiles }
                            />
                        </Grid>
                        <Grid size={4} marginTop={1}>
                            <Checkbox
                                label={ i18n.dontfindFic }
                                onChange={ v => this.onChangeFilters(v ? { dontProcessFilesInLogs: true, renameProcessedFiles: false } : { dontProcessFilesInLogs: false }) }
                                disabled={ disabled }
                                checked={ filters.dontProcessFilesInLogs }
                            />
                        </Grid>
                        <Grid size={4} marginTop={1}>
                            <Checkbox
                                label={ i18n.replayErrorFiles }
                                onChange={ v => this.onChangeFilters({ replayErrorFiles: v }) }
                                disabled={ disabled }
                                checked={ filters.replayErrorFiles }
                            />
                        </Grid>
                        <Grid size={2} marginTop={1}>
                            <Checkbox
                                label={ i18n.hasHeader }
                                onChange={ v => this.onChangeFilters({ hasHeader: v }) }
                                disabled={ disabled }
                                checked={ filters.hasHeader }
                            />
                        </Grid>
                        <Grid size={2}>
                            <NumberField
                                title={ i18n.nbLine }
                                value={ filters.nbHeaders }
                                onChange={ v => this.onChangeFilters({ nbHeaders: v }) }
                                disabled={ disabled }
                                floatValue
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems='center' margin={1}>
                        <Grid size={3}>
                            <Input
                                title={ i18n.directory }
                                value={ this.props.job.parameters.path }
                                onChange={ v => this.onChangeJobParameter({ path: v }) }
                                disabled={ disabled }
                                obligatory={true}
                            />
                        </Grid>
                        <Grid size={1} justifyContent='center'>
                            <Button
                                variant='contained'
                                onClick={ () => this.setAdvancedFtpModal()}
                            >
                                <InputIcon />
                            </Button>
                        </Grid>
                        <Grid size={2}>
                            <Input
                                title={ i18n.formatDate }
                                value={ filters.dateFormat }
                                onChange={ v => this.onChangeFilters({ dateFormat: v }) }
                                disabled={ disabled }
                                placeholder='ex: dd/MM/YYYY-HH:mm:ss'
                            />
                        </Grid>
                        <Grid size={3} marginTop={1}>
                            <Checkbox
                                label={ i18n.dateandHour }
                                onChange={ v => this.onChangeFilters({ hourWithDate: v }) }
                                disabled={ disabled }
                                checked={ filters.hourWithDate }
                            />
                        </Grid>
                        <Grid size={3}>
                            <Input
                                title={ i18n.defaultHour }
                                value={ filters.defaultHour }
                                onChange={ v => this.onChangeFilters({ defaultHour: v }) }
                                disabled={ disabled }
                                placeholder='ex: 15:00:00'
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} margin={1} alignItems='center'>
                        <Grid size={2}>
                            <Select
                                label={ i18n.dataType }
                                options={ dataTypes }
                                obligatory={true}
                                value={ filters.dataCategory }
                                onChange={ this.onChangeDataCategory }
                                disabled={ disabled }
                            />
                        </Grid>
                        <Grid size={3} marginTop={2}>
                            <Select
                                options={ getIntegrationModes() }
                                obligatory={true}
                                label={ i18n.dataIntegration }
                                value={ filters.importMode }
                                labelSpan={ <IntegrationModeDialog /> }
                                onChange={ v => this.onChangeFilters({ importMode: v }) }
                                disabled={ !this.props.isEditMode }
                            />
                        </Grid>
                        <Grid size={2}>
                            <Input
                                title={ i18n.excludedValue }
                                value={ filters.excludedValue }
                                onChange={ v => this.onChangeFilters({ excludedValue: v }) }
                                disabled={ disabled }
                            />
                        </Grid>
                        { filters.dataCategory && filters.dataCategory != STATION_TYPE_NAME.pluviometry &&
                                <Grid size={3}>
                                    <RadioButtons
                                        elements={getMeasureCoteList()}
                                        selected={filters.measureCote}
                                        onChange={v => this.onChangeFilters({ measureCote: v })}
                                        title={i18n.ratingExpression}
                                        titleAction={<ReferenceLevelHelp stationType={filters.dataCategory === STATION_TYPE_NAME.hydrometry ? STATION_TYPE_NAME.hydrometry : STATION_TYPE_NAME.piezometry} />}
                                        disabled={disabled}
                                    />
                                </Grid>
                        }
                        <Grid size={2} marginTop={1}>
                            <Checkbox
                                label={i18n.unzipFiles}
                                onChange={ v => this.onChangeFilters({ unzipFiles: v }) }
                                disabled={ disabled }
                                checked={ filters.unzipFiles }
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} margin={1} alignItems='center'>
                        { filters.dataCategory && filters.dataCategory == STATION_TYPE_NAME.installation &&
                            <Grid size={2}>
                                <Select
                                    options={ INSTALLATION_TYPES.map(i => ({
                                        value: i.code,
                                        label: i18n[i.label],
                                    }))}
                                    label={ i18n.installationType }
                                    value={ filters.installationType }
                                    onChange={ v => this.onChangeFilters({ installationType: v }) }
                                    obligatory={true}
                                    disabled={ !this.props.isEditMode }
                                />
                            </Grid>
                        }
                        <Grid size={4} marginTop={1}>
                            <Checkbox
                                label={ i18n.predictMode }
                                onChange={ v => this.onChangeFilters({ predictMode: v }) }
                                disabled={ disabled }
                                checked={ filters.predictMode }
                            />
                        </Grid>
                        <Grid size={4}>
                            <Input
                                title={ i18n.dataSource }
                                value={ filters.predSource }
                                onChange={ v => this.onChangeFilters({ predSource: v }) }
                                disabled={ disabled || !filters.predictMode }
                            />
                        </Grid>
                    </Grid>
                    <Grid size={6} margin={1}>
                        <Typography>{ i18n.indexStartsAt0 }</Typography>
                    </Grid>
                    <CardTable
                        rows={ parameters }
                        headers={ filtersHeaders }
                        headersLabel = { customHeaders }
                        title={ i18n.credentials }
                        rowsPerPageOptions={ nbPerPageLabelMedium }
                        data-cy='CsvGeneric_table'
                        lineActions={[{
                            icon: 'delete',
                            onClick: (p) => this.onDeleteParameter(p.INDEX_VALUE_ROW),
                            tooltip: i18n.delete,
                            displayed: this.props.isEditMode,
                        }, {
                            icon: 'add_to_photos',
                            onClick: (p) => this.onDuplicateParameter(p.INDEX_VALUE_ROW),
                            tooltip: i18n.duplicate,
                            displayed: this.props.isEditMode,
                        }]}
                        actions={[{
                            icon: 'add_box',
                            onClick: () =>{
                                if (this.props.isEditMode) {
                                    const jobParameters = {
                                        ...this.props.job.parameters,
                                        parameters: [ ...this.props.job.parameters.parameters, '{}'],
                                    }
                                    this.props.onChangeJob({ parameters: jobParameters })
                                }
                            },
                            tooltip: i18n.add,
                            displayed: this.props.isEditMode,
                        }, {
                            icon: 'build',
                            onClick: () => this.setAdvancedModal(filters),
                            tooltip: i18n.advanced,
                            displayed: this.props.isEditMode,
                        }, {
                            icon: 'clear',
                            onClick: this.clearParameters,
                            tooltip: i18n.deleteAll,
                            displayed: this.props.isEditMode,
                        }, {
                            icon: 'file_upload',
                            onClick: () => this.setState({ importParamsPopupIsOpen: true }),
                            tooltip: i18n.importFile,
                            displayed: this.props.isEditMode,
                        }, {
                            icon: 'download',
                            onClick: () => {
                                const headersTranslate = fileHeaders.map(h => customHeaders[h] || i18n[h])
                                JobAction.jobCsvExport(fileHeaders, headersTranslate, this.getParametersNew())
                            },
                            tooltip: i18n.download,
                        }]}
                    />
                    { this.importParamsPopin(fileHeaders, filters.dataCategory) }
                    <Dialog
                        fullWidth
                        maxWidth='lg'
                        open={hasValue(tmpDataCategory)}
                    >
                        <DefaultDialogTitle title={i18n.payAttention} onClose={() => this.setState({ tmpDataCategory: undefined })}/>
                        <DialogContent className='padding-top-1 padding-bottom-0'>
                            <h4 style={{ textAlign: 'center' }}>{i18n.ifChangeDataTypeFollowingItemsRemoved}</h4>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.setState({ tmpDataCategory: undefined })} variant='outlined' color='primary'>
                                {i18n.cancel}
                            </Button>
                            <Button onClick={() => this.updateDataCategory(tmpDataCategory)} variant='contained' color='primary'>
                                {i18n.validate}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Grid>
            )
        }
        return <ProgressCard progress={ this.state.progress }/>
    }
}

CSVGenericPanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    onChangeJob: PropTypes.func.isRequired,
    piezometryDataTypes: arrayOf(DtoParametrageDataType),
    piezometers: arrayOf(DtoPiezometerLight),
    pluviometers: arrayOf(PluviometerDto),
    pluviometryDataTypes: arrayOf(DtoParametrageDataType),
    hydrometricStations: arrayOf(DtoHydrometricStation),
    hydrometryDataTypes: arrayOf(DtoParametrageDataType),
    installationDataTypes: arrayOf(DtoParametrageDataType),
    installations: arrayOf(DtoInstallationLight),
    pointsPrelByType: PropTypes.objectOf(PropTypes.arrayOf(ShapePointPrelLight)),
    sandreCodes: arrayOf(DtoSandreCode),
    contributors: arrayOf(DtoContributor),
    isEditMode: PropTypes.bool,
    fetchFullJob: PropTypes.func,
}

const mapStateToProps = store => ({
    piezometryDataTypes: store.PiezometryReducer.piezometryDataTypes,
    piezometers: store.PiezometryReducer.piezometersLight,
    pluviometers: store.PluviometryReducer.pluviometers,
    pluviometryDataTypes: store.PluviometryReducer.pluviometryDataTypes,
    hydrometricStations: store.HydrometryReducer.hydrometricStations,
    hydrometryDataTypes: store.HydrometryReducer.hydrometryDataTypes,
    installationDataTypes: store.InstallationReducer.installationDataTypes,
    installations: store.InstallationReducer.installationsLight,
    pointsPrelByType: store.StationReducer.pointsPrelByType,
    sandreCodes: store.ReferencialReducer.sandreCodes,
    contributors: store.ContributorReducer.contributors,
})

const mapDispatchToProps = {
    fetchFullJob: JobAction.fetchFullJob,
}

export default connect(mapStateToProps, mapDispatchToProps)(CSVGenericPanel)
